import React, { FC } from 'react'
import TopupSelect from 'components/TopupSelect'
import SubscriptionSelect from 'components/SubscriptionSelect'
import PreviewBar from 'components/PreviewBar'
import usePreview from 'project/usePreview'
import { useDefaultSubscription } from 'common/services/useDefaultSubscription'
import { kycNeedsVerifying } from 'common/services/useKycStatus'
import Icon from 'project/Icon'
import Link from 'next/link'
import { useFlags } from 'flagsmith/react'
import SiteSearch from 'components/SiteSearch'
import useRequiresKYC from 'common/useRequiresKYC'

type ComponentType = {
  extraLinks?: React.ReactNode
}

const Nav: FC<ComponentType> = ({ extraLinks }) => {
  const { preview } = usePreview()
  const { subscriptionDetail } = useDefaultSubscription()
  const kyc = subscriptionDetail?.kyc_status
  const requiresKYC = useRequiresKYC()
  const needsVerify = kycNeedsVerifying(subscriptionDetail) && requiresKYC

  const { feature_kyc, feature_topups } = useFlags([
    'feature_topups',
    'feature_kyc',
  ])
  return (
    <>
      <nav className='navbar py-0 mt-10 navbar-expand-md nav-root'>
        <div
          className='gap-5 d-flex w-100 flex-row justify-content-between align-items-center'
          id='navbarCollapse'
        >
          <div className='flex-1'>
            <SiteSearch />
          </div>
          <div className='d-flex flex-row align-items-center gap-5 me-5'>
            {feature_topups.enabled && <TopupSelect />}
            <SubscriptionSelect />
          </div>
        </div>
      </nav>
      <PreviewBar />
      <div className=''>
        {!!needsVerify && (
          <div className='container-fluid'>
            <div className={'text-white rounded-lg bg-danger mb-4 py-3 px-4'}>
              <div className='flex-row align-items-center'>
                <div className='flex-fill text-sm'>
                  <div className='flex-row align-items-center'>
                    <Icon
                      width={24}
                      height={24}
                      fill={'white'}
                      name={'warning'}
                    />
                    <h1 className='text-semibold mb-0 ms-2'>
                      Your company is not verified
                    </h1>
                  </div>
                  <div>
                    We cannot process any mail for your account until you have
                    verified your identity and proof of address
                  </div>
                </div>
                {!!feature_kyc.enabled && (
                  <>
                    {kyc?.kyc_link ? (
                      <a
                        href={kyc?.kyc_link}
                        target='_blank'
                        className='btn px-10 btn-outline-light'
                        rel='noreferrer'
                      >
                        <span>Verify</span>
                      </a>
                    ) : (
                      <Link
                        href={'/settings?tab=business#business-owners'}
                        className='btn px-10 btn-outline-light'
                        rel='noreferrer'
                      >
                        Verify
                      </Link>
                    )}
                  </>
                )}
              </div>
            </div>
          </div>
        )}
      </div>
    </>
  )
}

export default Nav
